import { defineStore } from "pinia"
import { ref } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export const useErrorPage = defineStore('errorPage', () => {

  const errorWatcherReady = ref(false)
  const updateErrorWatcherReady = (newErrorWatcherReady: boolean) => {
    errorWatcherReady.value = newErrorWatcherReady
  }

  const afterErrorRoute = ref<RouteLocationRaw | null>(null)
  const updateAfterErrorRoute = (newAfterErrorRoute: RouteLocationRaw) => {
    afterErrorRoute.value = newAfterErrorRoute
  }
  const initAfterErrorRoute = () => {
    afterErrorRoute.value = null
  }

  return {
    errorWatcherReady,
    afterErrorRoute,
    updateErrorWatcherReady,
    updateAfterErrorRoute,
    initAfterErrorRoute,
  }
})
